import { Button, Card, Icon, Intent, Tooltip, H3 } from '@blueprintjs/core';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { WavelightsState } from '../../types';
import { useCallback, useEffect, useState } from 'react';
import { getAllWavelightWaves } from '../../reducer';
import { WAVELIGHT_WAVES_ITEMS } from '../../routes';
import { formatDate } from '../../../../utils';
import { TimeBlock } from '../../pages/styles';
import { Wave } from '../../../../types';
import Table from '../../../../components/Table';
import { usePaginationSearchParams } from '../../../users/components/pagination/hooks';

interface AlgorithmTableProps {
  id: string;
}
const AlgorithmTable = ({ id }: AlgorithmTableProps) => {
  const { currentPage, setCurrentPage } = usePaginationSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { waveLightAlgorithms, wavesResponse }: WavelightsState =
    useAppSelector((state) => state.wavelight);

  const [itemsPerPage] = useState(10);

  useEffect(() => {
    if (waveLightAlgorithms.length > 0) {
      dispatch(
        getAllWavelightWaves({
          id: id as string,
          limit: itemsPerPage,
          page: currentPage,
        }),
      );
    }
  }, [dispatch, id, waveLightAlgorithms, currentPage, itemsPerPage]);

  // Move to Calculation Screen
  const openCalculationScreen = useCallback(
    (wid: string) => {
      navigate(WAVELIGHT_WAVES_ITEMS(id as string, wid));
    },
    [id, navigate],
  );

  return (
    <Card>
      <H3>Production Algorithm Results Table</H3>
      <Table<Wave>
        rowKey="_id"
        data={wavesResponse?.waves || []}
        pagination={{
          currentPage,
          totalPages: wavesResponse?.totalPages || 0,
          onPageChange: (pageNumber) => setCurrentPage(pageNumber),
        }}
        columns={[
          {
            title: 'ID',
            render: (record) => record._id,
          },
          {
            title: 'Algorítmo',
            render: (record) => record.algorithm,
          },
          {
            title: 'Versão',
            render: (record) => record.version,
          },
          {
            title: 'Created',
            render: (record) => formatDate(record.createdAt.toString()),
          },
          {
            title: 'Last Modified',
            render: (record) => formatDate(record.updatedAt.toString()),
          },
          {
            title: 'Computing',
            render: (record) =>
              record.computing ? <Icon icon="time" /> : <Icon icon="tick" />,
          },
          {
            title: 'Duração',
            render: (record) =>
              !record.process_time_taken ? (
                <Icon icon="time" />
              ) : (
                <TimeBlock>
                  <div>
                    <strong>D: </strong>
                    {`${Number(record.download_time_taken / 60).toFixed(2)} min`}
                  </div>
                  <div>
                    <strong>P: </strong>
                    {`${Number(record.process_time_taken / 60).toFixed(2)} min`}
                  </div>
                </TimeBlock>
              ),
          },
          {
            title: 'Ações',
            render: (record) => (
              <Tooltip
                content={<span>Cálculos</span>}
                openOnTargetFocus={false}
                usePortal={false}
              >
                <Button
                  disabled={record.computing}
                  onClick={() => openCalculationScreen(record._id)}
                  icon={'function'}
                  intent={Intent.PRIMARY}
                />
              </Tooltip>
            ),
          },
        ]}
      />
    </Card>
  );
};

export default AlgorithmTable;
